import { gql } from '@apollo/client';
import {
  PORTALIO_AUTH_DETAILS_FRAGMENT,
  PORTALIO_PROJECT_IMPORT_DETAILS,
} from './portalio.fragments';

export const PORTALIO_CONNECT = gql`
  mutation PortalioAuthenticate($params: PortalioAuthenticateInput!) {
    portalioAuthenticate(params: $params) {
      authDetails {
        id
        ...PortalioAuthDetails
      }
    }
  }
  ${PORTALIO_AUTH_DETAILS_FRAGMENT}
`;

export const PORTALIO_REVOKE_CONNECTION = gql`
  mutation PortalioRevokeAuthentication($params: PortalioRevokeAuthenticationInput!) {
    portalioRevokeAuthentication(params: $params) {
      userId
    }
  }
`;

export const GET_PORTALIO_AUTH_DETAILS = gql`
  query GetPortalioAuthConnections {
    getPortalioUserAuthDetails {
      authDetails {
        id
        ...PortalioAuthDetails
      }
    }
  }
  ${PORTALIO_AUTH_DETAILS_FRAGMENT}
`;

export const GET_PORTALIO_PROPOSALS_QUERY = gql`
  query GetPortalioProposals($params: GetPortalioProposalsInput!) {
    getPortalioProposals(params: $params) {
      records {
        id
        status
        name
        proposalNumber
        createdDate
        lastModifiedDate
        customer {
          id
          firstName
          lastName
        }
      }
      total
    }
  }
`;

export const GET_PORTALIO_PROPOSAL_DETAILS = gql`
  query GetPortalioProposalDetails($params: GetPortalioProposalDetailsInput!) {
    getPortalioProposalDetails(params: $params) {
      content
    }
  }
`;

export const GET_PORTALIO_PROJECT_IMPORT_PREVIEW = gql`
  query GetPortalioProjectImportPreview($params: ImportPortalioProjectInput!) {
    getPortalioProjectImportPreview(params: $params) {
      records {
        ...PortalioProjectImportDetails
      }
      errors {
        projectId
        error
      }
    }
  }
  ${PORTALIO_PROJECT_IMPORT_DETAILS}
`;

export const IMPORT_PORTALIO_PROJECT = gql`
  mutation ImportPortalioProject($params: ImportPortalioProjectInput!) {
    importPortalioProject(params: $params) {
      records {
        ...PortalioProjectImportDetails
      }
      errors {
        projectId
        error
      }
    }
  }
  ${PORTALIO_PROJECT_IMPORT_DETAILS}
`;
